import { AlertMessage } from 'app-components'
import { Link } from '@/app/components/Link'
import toExternalLink from '@/utils/to-external-link'
import { SHADOW_RATE_FAQ_URL } from './constants'
import { useShadowRateAlert } from './useShadowRateAlert'

/**
 * Informational alert shown on the Manage Utility Information page when any of
 * the user's devices is optimized to a program-prescribed ("shadow") rate
 * signal, so users understand their displayed plan isn't what their devices
 * actually optimize to while enrolled.
 */
export default function ShadowRateAlert() {
  const { prescribedProgram } = useShadowRateAlert()

  if (!prescribedProgram) {
    return null
  }

  const { name, sponsorName } = prescribedProgram

  return (
    <AlertMessage variant="info" className="mb-6">
      <div className="flex flex-col gap-2">
        <div>
          While you&apos;re enrolled in{' '}
          <span className="font-bold">{name}</span>, we&apos;ll optimize your
          devices to the rate plan chosen by{' '}
          {sponsorName ? (
            <span className="font-bold">{sponsorName}</span>
          ) : (
            'your utility program sponsor'
          )}
          .
        </div>
        <Link to={toExternalLink(SHADOW_RATE_FAQ_URL)} openInNewTab>
          Learn more here
        </Link>
      </div>
    </AlertMessage>
  )
}
